export default class RateApp {
    constructor(options) {
        let appName = options.appName || "App";
        let ios = options.ios || null;
        let android = options.android || null;
        let windows = options.windows || null;
        let amazon = options.amazon || null;
        let email = options.email || "jimmy@jdsoftwarellc.com";
        let emailSubject = options.emailSubject || appName + " Feedback";
        let os = options.os || this.getOS();
        
        this.os = os;
        this.appName = appName;
        this.ios = ios;
        this.iosUrl = 'itms-apps://itunes.apple.com/app/' + ios;
        this.android = 'market://details?id=' + android;
        this.amazon = 'amzn://apps/android?asin=' + amazon;
        this.windows = 'ms-windows-store://pdp/?ProductId=' + windows;
        this.email = "mailto:" + email + "?subject=" + emailSubject;
    }
    rate() {
        // //try native rate
        // let rated = this.rateNative();
        // if (rated) return true;

        return this.rateNonNative();
    }
    rateNative() {
        //rate app natively
        if (typeof cordova !== 'undefined' && cordova.plugins && cordova.plugins.RateAppNative && cordova.plugins.RateAppNative.rate) {
            cordova.plugins.RateAppNative.rate();
        }
    }

    rateNonNative() {
        let os = this.os;
        if (!os) os = this.getOS();

        if (os === "android") {
            window.open(this.android, "_system");
            return true;
        }
        if (os === "ios") {
            window.open(this.iosUrl, "_system");
            return true;
        }
        if (os === "amazon") {
            window.open(this.amazon, "_system");
            return true;
        }
        if (os === "windows") {
            window.open(this.windows, "_system");
            return true;
        }
    }
    getOS() {
        let os = null;

        var ua = navigator.userAgent;
        var isKindle = /Kindle|Silk|Amazon|KFDOWI|KFAPWA|KFSAW|KFGIWI|KFGIWI|KFAPW|KFARWI|KFTBWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFS‌​AW|KFSOWI|KFTBW|KFTH‌​W|KFTT|WFFOWI|KFJWA|KFJWI|KFTHWA|KFTHWI|KFAPWI|KFKAWI/i.test(ua);

        if (typeof FBInstant !== "undefined") {
            os = "FBMessenger";
            return os;
        }
        if (/(android)/i.test(navigator.userAgent) && isKindle) {
            os = "amazon";
        }
        else if (/(android)/i.test(navigator.userAgent) && !isKindle) {
            os = "android";
        }
        else if (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel') {
            os = "ios";
        }
        else if (/(windows phone)/i.test(navigator.userAgent)) {
            os = "windows";
        }
        else if (/(windows)/i.test(navigator.userAgent)) {
            os = "windows";
        }
        return os;
    }
}